(function () {
  'use strict';

  if (window.FsProductAffirm) return;

  var productSelector = '[data-section-type="product"]';
  var messageSelector = '[data-fs-affirm-message]';
  var boundContainers = new WeakSet();
  var waitingForSdk = false;

  function messagesIn(container) {
    return Array.from(container.querySelectorAll(messageSelector)).filter(function (message) {
      return message.closest(productSelector) === container;
    });
  }

  function hasAmount(message) {
    var amount = message.getAttribute('data-amount');
    return amount !== null && /^\d+$/.test(amount) && Number.isSafeInteger(Number(amount));
  }

  function refresh() {
    var ui = window.affirm && window.affirm.ui;
    if (waitingForSdk || !ui || typeof ui.ready !== 'function') return;
    if (!Array.from(document.querySelectorAll(messageSelector)).some(hasAmount)) return;

    waitingForSdk = true;
    try {
      ui.ready(function () {
        waitingForSdk = false;
        var currentUi = window.affirm && window.affirm.ui;
        if (!currentUi || typeof currentUi.refresh !== 'function') return;
        if (!Array.from(document.querySelectorAll(messageSelector)).some(hasAmount)) return;
        try {
          currentUi.refresh();
        } catch (_) {
          // The server-rendered financing note remains available if the SDK fails.
        }
      });
    } catch (_) {
      waitingForSdk = false;
    }
  }

  function updateProduct(container, variant) {
    var valid = variant && Number.isSafeInteger(variant.price) && variant.price >= 0;
    var amount = valid ? String(variant.price) : null;
    var changed = false;

    messagesIn(container).forEach(function (message) {
      if (message.getAttribute('data-amount') === amount) return;
      // Never keep a financing offer that belongs to a different item price.
      message.textContent = '';
      if (amount === null) message.removeAttribute('data-amount');
      else message.setAttribute('data-amount', amount);
      changed = true;
    });

    if (changed && valid) refresh();
  }

  function bindContainer(container) {
    if (boundContainers.has(container)) return;
    boundContainers.add(container);
    container.addEventListener('variantChange', function (event) {
      var variant = event.detail && event.detail.variant;
      if (container.matches(productSelector)) {
        updateProduct(container, variant);
      } else {
        container.querySelectorAll(productSelector).forEach(function (product) {
          updateProduct(product, variant);
        });
      }
    });
  }

  function init() {
    document.querySelectorAll(productSelector).forEach(function (product) {
      if (!messagesIn(product).length) return;
      bindContainer(product);
      // Quick-shop's native variant helper dispatches on the outer tooltip.
      var quickShop = product.closest('[data-tool-tip-content]');
      if (quickShop) bindContainer(quickShop);
    });
    refresh();
  }

  window.FsProductAffirm = { init: init };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else init();

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('product-component:loaded', init);
  document.addEventListener('quickshop:opened', init);
  document.addEventListener('quickshop:product-blocks-loaded', function () {
    // The native loader emits this event immediately before inserting the blocks.
    Promise.resolve().then(init);
  });
})();
